/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    object, shape, func, number, bool, string, oneOfType,
} from 'prop-types';
import { withRouter } from 'react-router';
import Media from 'react-media';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/Check';
import { bindActionCreators } from 'redux';
import { format } from 'date-fns';
import AutoRenewal from './AutoRenewal';
import CUSTOM_BREAKPOINTS from '../../../style/customBreakpoints';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
import CancelSubscriptionModal from './CancelSubscriptionModal';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getPassportPageUrl, getDeviceType } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import AccountHome from '../../MyAccount/AccountHome';
import { getPassportData } from '../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import validatePassport from '../../../../../helpers/validatePassport';
import { updateUserProfileDetails } from '../../../../../../state/ducks/Member/ducks/Profile/Profile-Actions';
import useGetAccessTokenSafely from '../../../../../gql/hooks/useGetAccessTokenSafely';
import { setTokenLocalStorage } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const { PERSIST_KEY } = configENV;

const styles = (theme) => ({
    root: {
        display: 'block',

        [theme.breakpoints.up(CUSTOM_BREAKPOINTS.tabLandscape)]: {
            display: 'flex',
        },
    },
    container: {
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    headerButton: {
        // overwrite default button styles
        cursor: 'pointer',
        fontSize: '14px !important',
        fontWeight: '700 !important',
        textTransform: 'uppercase',
        textDecoration: 'underline !important',
        color: '#000 !important',
        backgroundColor: 'transparent !important',
        border: 'none !important',
        padding: '5px 10px !important',
        borderRadius: '50px !important',
        marginRight: '0 !important',
        '&:hover': {
            boxShadow: '-2px -2px 5px #fff, 2px 2px 5px #babecc !important',
            textDecoration: 'none !important',
        },
        '&:active': {
            boxShadow: 'inset 1px 1px 2px #babecc, inset -1px -1px 2px #fff !important',
            textDecoration: 'none !important',
        },
    },
    block: {
        border: 'none',
        width: '100%',

        [theme.breakpoints.up('md')]: {
            boxShadow: '0px 0px 10px rgb(47 47 47 / 25%)',
            margin: '40px 11px 0 43px',
            width: '900px',
        },
    },
    blockHeader: {
        backgroundColor: 'rgba(234, 234, 234, 1)',
        padding: '5px 20px',

    },
    link: {
        display: 'flex',
        alignItems: 'center',
    },
    blockHeading: {
        textTransform: 'uppercase',
    },
    linkText: {
        marginBottom: '0px !important',
        fontSize: '1rem !important',
    },
    blockBody: {
        margin: '20px 10px',
    },
    col: {
        flex: 1,
        letterSpacing: '0.4px',
    },
    col2: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        letterSpacing: '0.4px',

        [theme.breakpoints.up('md')]: {
            marginTop: '4px',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
        },
    },
    entry: {
        margin: '7px 20px',
        display: 'block',

        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            alignItems: 'flex-start',
        },
    },
    entry2: {
        margin: '1px 20px',

        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
        },

        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    statusEntry: {
        margin: '0px 20px',
        display: 'block',

        [theme.breakpoints.up('xs')]: {
            display: 'flex',
            alignItems: 'flex-start',
        },
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        margin: '8px 10px',
    },
    centerEntry: {
        textAlign: 'center',
        margin: '15 px 20px',
    },
    boldText: {
        fontWeight: 900,
    },
    boldUpText: {
        fontWeight: 900,
        textTransform: 'uppercase',
        display: 'block',
    },
    greenText: {
        fontWeight: 900,
        color: 'green !important',
    },
    redText: {
        fontWeight: 900,
        color: 'red',
        textAlign: 'center',
    },
    secondaryCta: {
        backgroundColor: 'transparent !important',
        color: '#2f2f2f !important',
        border: '0 !important',
        borderRadius: '0 !important',
        boxShadow: 'none !important',
        minWidth: '0 !important',
        padding: '0 !important',
        fontWeight: '900 !important',
        textDecoration: 'underline !important',
        textTransform: 'capitalize !important',
        '&:hover': {
            backgroundColor: 'transparent !important',
            boxShadow: 'none !important',
            textDecoration: 'underline !important',
        },
    },
    renewalLoading: {
        cursor: 'wait !important',
        opacity: '0.7 !important',
    },
    renewalSpinner: {
        marginRight: '8px',
        color: 'inherit !important',
    },
    focusVisible: {},
    earnBtn: {
        backgroundColor: `${theme.palette.common.black} !important` || '#000000',
        color: theme.palette.common.white || '#FFFFFF',
        border: '0 !important',
        borderRadius: '100px !important',
        padding: '10px 30px !important',
    },
    earnBtnMobile: {
        backgroundColor: `${theme.palette.common.black} !important` || '#000000 !important',
        color: theme.palette.common.white || '#FFFFFF',
        border: '0 !important',
        borderRadius: '100px !important',
        textDecoration: 'none',
        padding: '2px 17px',
        fontSize: '10px !important',
        textAlign: 'center',
        lineHeight: 'normal',
    },
    autoRenewalContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '1rem',
        margin: '0 20px',
    },
    passportLinks: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '24px',
        margin: '0 20px 36px',
    },
    passportLink: {
        color: '#2f2f2f',
        textDecoration: 'underline',
    },
    passportDivider: {
        border: '0',
        borderTop: '1px solid #e5e5e5',
        margin: '0 20px 48px',
    },
    renewalCtaContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
    },
    passportAddedCard: {
        width: '100%',
        maxWidth: '428px',
        overflow: 'hidden',
        border: '1px solid #e5e5e5',
        borderRadius: '8px',
        backgroundColor: '#fff',
    },
    passportAddedHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '12px',
        backgroundColor: '#f0faf4',
        color: '#08783f',
        fontWeight: 900,
    },
    passportAddedCheck: {
        marginRight: '6px',
        fontSize: '20px',
    },
    passportAddedBody: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        padding: '16px 12px 12px',
    },
    passportAddedTitle: {
        margin: 0,
        fontWeight: 900,
    },
    passportAddedCopy: {
        margin: 0,
        lineHeight: '1.45',
    },
    proceedToCheckoutButton: {
        backgroundColor: '#08783f !important',
        color: '#fff !important',
        border: '0 !important',
        borderRadius: '2px !important',
        padding: '8px 16px !important',
        textTransform: 'none !important',
        '&:hover': {
            backgroundColor: '#08783f !important',
            border: '0 !important',
        },
    },
    divider: {
        height: '1px',
        backgroundColor: '#EAEAEA',
        marginBottom: '20px',
    },

});

const breakpointExpr = `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;

const Passport = ({
    classes,
    userDetails,
    handleSubscriptionRenewal,
    isPassportInCart,
    handleCheckout,
    featureFlags,
    userProfile,
    fetchPassportAutoRenewalStatus,
    autoRenewalStatus,
    updatePassportAutoRenewalStatus,
    daysDifference,
    statusUpdateError,
    autoRenewalStatusError,
    trackPassportEvent,
    updatedAutoRenewFlag,
    setPassportAutoRenewalStatus,
    passportPageUrl,
    deviceType,
    history,
    passportData,
    cancelPassportMembership,
    cancelPassportMembershipStatus,
    cancelPassportMembershipStatusError,
    clearCancelPassportMembershipState,
    updateUserProfile,
    earlyRenewalPrice,
    renewalPrice,
    newEndDate,
    passportLoader,
    passportError,
}) => {
    const [cancelPassportMembershipModal, setCancelPassportMembershipModal] = React.useState(false);
    const [cancelPassportMembershipError, setCancelPassportMembershipError] = React.useState(false);
    const [cancelPassportMembershipSuccess, setCancelPassportMembershipSuccess] = React.useState(false);
    const [isAutoRenewDisabled, setIsAutoRenewDisabled] = React.useState(false);
    const [autoRenewError, setAutoRenewError] = React.useState(false);
    const [renderStatus, setRenderStatus] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isRenewalPending, setIsRenewalPending] = React.useState(false);
    const [hasPassportLoaderStarted, setHasPassportLoaderStarted] = React.useState(false);
    const isDesktop = deviceType === 'desktop';
    const jwt = useGetAccessTokenSafely();

    if (!renderStatus && autoRenewalStatus?.isAutoRenew === undefined) {
        fetchPassportAutoRenewalStatus(userDetails.email);
        setRenderStatus(true);
    }

    const isCancelledPassport = () => {
        if (autoRenewalStatus?.cancellationDate && userProfile?.passportFlag === '01-03') return true;
        return false;
    };

    useEffect(() => {
        let status;
        if (updatedAutoRenewFlag?.autoRenewFlag === undefined) {
            status = autoRenewalStatus?.isAutoRenew;
        } else {
            status = updatedAutoRenewFlag?.autoRenewFlag;
        }
        if (status === undefined || (typeof status === 'string')) return;

        setPassportAutoRenewalStatus({ ...autoRenewalStatus, isAutoRenew: status });
    }, [updatedAutoRenewFlag?.autoRenewFlag]);

    useEffect(() => {
        // If passport expiration date is due in 2 days or failed to get auto renew status, hide auto renew feature
        if (daysDifference >= -2 || autoRenewalStatusError) setIsAutoRenewDisabled(true);
        // if auto renew update failed, render error message
        if (statusUpdateError) {
            setAutoRenewError(true);
            trackPassportEvent({
                eventCategory: 'account',
                eventAction: 'pp auto renew failure',
                eventLabel: 'passport',
                eventValue: 1,
            });
        }
    }, [statusUpdateError, autoRenewalStatusError]);

    useEffect(() => {
        setIsLoading(false);
        if (cancelPassportMembershipStatusError !== '') setCancelPassportMembershipError(true);
        if (cancelPassportMembershipStatus.result?.includes('success')) {
            const canceledPassportUser = {
                token: jwt,
                profile: {
                    ...userProfile, passportFlag: '01-03', membershipType: 'R', userRole: '',
                },
            };
            fetchPassportAutoRenewalStatus(userDetails.email);
            setCancelPassportMembershipSuccess(true);
            updateUserProfile(canceledPassportUser);
            setCancelPassportMembershipError(false);
            trackPassportEvent({
                eventCategory: 'account',
                eventAction: 'passport cancelled',
                eventLabel: 'passport',
            });
            setTimeout(() => {
                setCancelPassportMembershipModal(false);
            }, 3000);
            setTokenLocalStorage(true, 'refreshMetadata');
        }
    }, [cancelPassportMembershipStatus, cancelPassportMembershipStatusError]);

    useEffect(() => {
        if (!isRenewalPending) return;

        if (passportLoader) {
            setHasPassportLoaderStarted(true);
            return;
        }

        if (hasPassportLoaderStarted || isPassportInCart || passportError) {
            setIsRenewalPending(false);
            setHasPassportLoaderStarted(false);
        }
    }, [passportLoader, isRenewalPending, hasPassportLoaderStarted, isPassportInCart, passportError]);

    const handleCPMModalClose = () => {
        trackPassportEvent({
            eventCategory: 'account',
            eventAction: 'closeed pp cancellation modal',
            eventLabel: 'passport',
        });
        setCancelPassportMembershipModal(false);
        setCancelPassportMembershipError(false);
        clearCancelPassportMembershipState();
    };

    const handleCancelMembership = () => {
        trackPassportEvent({
            eventCategory: 'account',
            eventAction: 'clicked on Yes, Cancel',
            eventLabel: 'passport',
        });
        setIsLoading(true);
        clearCancelPassportMembershipState();
        setCancelPassportMembershipError(false);
        cancelPassportMembership({ emailId: userProfile.email, contactId: userProfile.contactId });
    };

    const handleCancelPpBtn = () => {
        setCancelPassportMembershipModal(true);
        trackPassportEvent({
            eventCategory: 'account',
            eventAction: 'clicked on Cancel Membership',
            eventLabel: 'passport',
        });
    };

    let passport_item;
    let cta_copy = '';
    const pp_copy = (message, price) => message?.replace('{passport_price}', `$${price}`) || '';
    const isCancelledMembership = isCancelledPassport();

    if (featureFlags['is-renew-early-pricing-on'] && validatePassport('isExpiringPassportUser', passportData)) { // passport membership about to exprire
        passport_item = passportData?.myaccount_passport?.renew_early_button_passport_price?.passport_referenced_sku?.[0];
        cta_copy = passportData?.myaccount_passport?.renew_early_button_passport_price?.cta_copy || '';
    } else if (featureFlags['is-passport-enabled'] && validatePassport('isExpiredPassportUser', passportData)) { // expired and cancelled members use the regular CMS renewal price
        passport_item = passportData?.myaccount_passport?.renew_button_passport_price?.passport_referenced_sku?.[0];
        cta_copy = passportData?.myaccount_passport?.renew_button_passport_price?.cta_copy || '';
    }

    let membershipRenewalButton = cta_copy ? pp_copy(cta_copy, passport_item.price) : 'Renew';
    let memberShipStatus = <p className={classes.redText}>&nbsp; Inactive</p>;
    if (userDetails?.isActive) {
        membershipRenewalButton =  cta_copy ? pp_copy(cta_copy, passport_item.price) : 'Renew Early';
        memberShipStatus = <p className={classes.greenText}>&nbsp; Active</p>;
    }
    if (isCancelledMembership) {
        membershipRenewalButton =  cta_copy ? pp_copy(cta_copy, passport_item.price) : 'Renew';
        memberShipStatus = <p className={classes.redText}>&nbsp; Inactive</p>;
    }

    const handleRenewalClick = () => {
        if (isRenewalPending || passportLoader) return;

        setIsRenewalPending(true);
        setHasPassportLoaderStarted(false);
        handleSubscriptionRenewal(passport_item?.passport_item_sku);
    };

    const isRenewalLoading = isRenewalPending || passportLoader;
    const shouldShowRenewalCta = userDetails?.isActive
        ? userDetails?.showRenewalBtn
        : featureFlags['is-passport-enabled'];

    return (
        <>
            <div className={classes.root}>
                <Media query={breakpointExpr}>
                    {(matches) => (
                        matches ? (
                            <h1>
                                <AccountHome />
                                Passport
                            </h1>
                        )
                            : (
                                <AccountLeftMenu
                                    userProfile={userProfile}
                                    featureFlags={featureFlags}
                                />
                            )
                    )}
                </Media>
                <div className={classes.block}>
                    <div className={classes.blockHeader}>
                        <div className={classes.headerContainer}>
                            <h3 className={classes.blockHeading}>Membership Details</h3>
                            {
                                featureFlags['is-passport-cancel-button-on'] && !isCancelledPassport() && !validatePassport('isExpiredPassportUser', passportData) && (
                                    <button type="button" onClick={handleCancelPpBtn} className={classes.headerButton}>
                                        Cancel Membership
                                    </button>
                                )
                            }
                        </div>
                    </div>
                    <div className={classes.blockBody}>
                        <div className={classes.container}>
                            <div className={classes.col}>
                                <div className={classes.entry}>
                                    <p className={classes.boldText}>Member Email:</p>
                                    <p className={classes.text}>&nbsp;{userDetails?.email}</p>
                                </div>
                                <div className={classes.entry}>
                                    <p className={classes.boldText}>Member Since:</p>
                                    <p className={classes.text}>&nbsp;{userDetails?.memberSince}</p>
                                </div>
                            </div>
                            <div className={classes.col2}>
                                <div className={classes.entry2}>
                                    <p className={classes.boldText}>Membership Start Date:</p>
                                    <p className={classes.text}>&nbsp;{userDetails?.startDate}</p>
                                </div>
                                <div className={classes.entry2}>
                                    <p className={classes.boldText}>{isCancelledPassport() ? 'Membership Cancelation Date:' : 'Membership End Date'}</p>
                                    <p className={classes.text}>&nbsp;{isCancelledPassport() ? format(new Date(autoRenewalStatus?.cancellationDate), 'MMMM d, yyyy') : userDetails?.endDate}</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.container}>
                            <div className={classes.col}>
                                <div className={classes.statusEntry}>
                                    <p className={classes.boldText}>Status:</p>
                                    {memberShipStatus}
                                </div>
                                {userDetails?.message && (
                                    <p className={`${classes.redText} ${userDetails?.successMsg ? classes.greenText : ''}`}>
                                        {userDetails.message}
                                    </p>
                                )}
                                <div className={classes.passportLinks}>
                                    <a className={classes.passportLink} href="/passport-terms-and-conditions">Celebrations Passport Terms & Conditions</a>
                                    <a className={classes.passportLink} href={passportPageUrl}>Frequently Asked Questions</a>
                                </div>
                                <div className={classes.divider} />
                                {shouldShowRenewalCta && <hr className={classes.passportDivider} />}
                                <div className={classes.autoRenewalContainer}>
                                    {featureFlags['is-passport-autorenew-button-on'] && !isAutoRenewDisabled && !isCancelledPassport() && (
                                        <AutoRenewal
                                            userDetails={userDetails}
                                            autoRenewalStatus={autoRenewalStatus?.isAutoRenew}
                                            renewalPrice={renewalPrice}
                                            updateAutoRenewal={updatePassportAutoRenewalStatus}
                                            statusUpdateError={statusUpdateError}
                                        />
                                    )}
                                    <div className={classes.renewalCtaContainer}>
                                        {shouldShowRenewalCta
                                            && (!isPassportInCart
                                                ? (
                                                    <Button
                                                        className={`${classes.secondaryCta} ${isRenewalLoading ? classes.renewalLoading : ''}`}
                                                        onClick={handleRenewalClick}
                                                        disabled={isRenewalLoading}
                                                        aria-busy={isRenewalLoading}
                                                    >
                                                        {isRenewalLoading ? (
                                                            <span aria-live="polite">
                                                                <CircularProgress className={classes.renewalSpinner} size={14} aria-hidden="true" />
                                                                Adding to cart…
                                                            </span>
                                                        ) : membershipRenewalButton.toLowerCase()}
                                                    </Button>
                                                )
                                                : (
                                                    <div className={classes.passportAddedCard}>
                                                        <div className={classes.passportAddedHeader}>
                                                            <CheckIcon className={classes.passportAddedCheck} />
                                                            Added to your cart!
                                                        </div>
                                                        <div className={classes.passportAddedBody}>
                                                            <p className={classes.passportAddedTitle}>Celebrations Passport® - ${earlyRenewalPrice}</p>
                                                            <p className={classes.passportAddedCopy}>Your new expiration date will be {newEndDate} when you complete checkout. Automatically renews at ${renewalPrice}/year. Turn off Auto-Renewal any time.</p>
                                                            <Button className={classes.proceedToCheckoutButton} onClick={handleCheckout}>
                                                                Proceed to Checkout
                                                            </Button>
                                                        </div>
                                                    </div>
                                                ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            {autoRenewError
                                && (
                                    <span className={classes.redText}>
                                        There was an error while updating your auto renewal status. Please contact our customer service at 844-810-6091.
                                    </span>
                                )}
                        </div>
                        {/* <div className={classes.centerEntry}>
                            <span>
                                *Your default card will be used for Passport membership renewals.
                            </span>
                        </div> */}
                    </div>
                </div>
            </div>
            {cancelPassportMembershipModal && <CancelSubscriptionModal isLoading={isLoading} cancelPassportMembershipSuccess={cancelPassportMembershipSuccess} cancelPassportMembership={handleCancelMembership} cancelPassportMembershipError={cancelPassportMembershipError} close={handleCPMModalClose} open={cancelPassportMembershipModal} />}
        </>
    );
};

Passport.defaultProps = {
    isPassportInCart: false,
    handleCheckout: () => { },
    featureFlags: shape({
        'is-passport-cancel-button-on': bool,
        'is-passport-autorenew-button-on': bool,
    }),
    userDetails: shape({
        email: string,
        memberSince: number,
        startDate: string,
        endDate: string,
        renewalDate: string,
        showRenewalBtn: bool,
        isActive: bool,
        message: string,

    }),
    userProfile: {},
    fetchPassportAutoRenewalStatus: () => { },
    updatePassportAutoRenewalStatus: () => { },
    cancelPassportMembership: () => { },
    clearCancelPassportMembershipState: () => { },
    updateUserProfile: () => { },
    cancelPassportMembershipStatus: {},
    cancelPassportMembershipStatusError: '',
    autoRenewalStatus: {},
    daysDifference: number,
    statusUpdateError: '',
    autoRenewalStatusError: '',
    setPassportAutoRenewalStatus: () => { },
    updatedAutoRenewFlag: {},
    passportData: {},
    earlyRenewalPrice: '',
    passportLoader: false,
    passportError: '',
    renewalPrice: '',
    newEndDate: '',
};

Passport.propTypes = {
    classes: object.isRequired,
    history: object.isRequired,
    handleSubscriptionRenewal: func.isRequired,
    isPassportInCart: bool,
    handleCheckout: func,
    featureFlags: {},
    userDetails: {},
    userProfile: {},
    fetchPassportAutoRenewalStatus: func,
    updatePassportAutoRenewalStatus: func,
    autoRenewalStatus: object,
    cancelPassportMembership: func,
    updateUserProfile: func,
    cancelPassportMembershipStatus: object,
    clearCancelPassportMembershipState: object,
    cancelPassportMembershipStatusError: string,
    daysDifference: number,
    statusUpdateError: string,
    autoRenewalStatusError: string,
    trackPassportEvent: func.isRequired,
    setPassportAutoRenewalStatus: func,
    updatedAutoRenewFlag: object,
    passportPageUrl: string.isRequired,
    deviceType: string.isRequired,
    passportData: {},
    earlyRenewalPrice: oneOfType([number, string]),
    passportLoader: bool,
    passportError: string,
    renewalPrice: oneOfType([number, string]),
    newEndDate: string,
};

const mapDispatchToProps = (dispatch) => ({
    fetchPassportAutoRenewalStatus: (payload) => dispatch(EventDispatcher.handleFetchPassportAutoRenewalStatus(payload)),
    updatePassportAutoRenewalStatus: (payload) => dispatch(EventDispatcher.updatePassportAutoRenewalStatus(payload)),
    cancelPassportMembership: (payload) => dispatch(EventDispatcher.cancelPassportMembership(payload)),
    clearCancelPassportMembershipState: () => dispatch(EventDispatcher.clearCancelPassportMembershipState()),
    trackPassportEvent: bindActionCreators(track, dispatch),
    setPassportAutoRenewalStatus: (payload) => dispatch(EventDispatcher.setPassportAutoRenewalStatus(payload)),
    updateUserProfile: (payload) => dispatch(updateUserProfileDetails(payload)),
});

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        autoRenewalStatus: newState?.autoRenewalStatus,
        autoRenewalStatusError: newState?.autoRenewalStatusError,
        cancelPassportMembershipStatus: newState?.cancelPassportMembershipStatus,
        cancelPassportMembershipStatusError: newState?.cancelPassportMembershipStatusError,
        statusUpdateError: newState?.statusUpdateError,
        updatedAutoRenewFlag: newState?.data,
        passportPageUrl: getPassportPageUrl(state),
        deviceType: getDeviceType(state),
        passportData: getPassportData(state),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles)(Passport)));
